 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"Account":"Account","Admin/Dashboard~Admin/Engagement":"Admin/Dashboard~Admin/Engagement","Admin/Dashboard":"Admin/Dashboard","Admin/Engagement":"Admin/Engagement","Admin/FavPages/FavPages":"Admin/FavPages/FavPages","Admin/FavPages/FavPage~FaveItButton~FavesByCountryName.~Home~TopBlogs~TopFaves~TopGames~WeeklyFaves~~1581b57c":"Admin/FavPages/FavPage~FaveItButton~FavesByCountryName.~Home~TopBlogs~TopFaves~TopGames~WeeklyFaves~~1581b57c","Admin/FavPages/FavPage~FaveItButton~Home":"Admin/FavPages/FavPage~FaveItButton~Home","Admin/FavPages/FavPage":"Admin/FavPages/FavPage","FaveItButton":"FaveItButton","FavesByCountryName.~Home~TopBlogs~TopFaves~TopGames~WeeklyFaves~WeeklyGames~categories":"FavesByCountryName.~Home~TopBlogs~TopFaves~TopGames~WeeklyFaves~WeeklyGames~categories","Home":"Home","FavesByCountryName.":"FavesByCountryName.","TopBlogs":"TopBlogs","TopFaves":"TopFaves","TopGames":"TopGames","WeeklyFaves":"WeeklyFaves","WeeklyGames":"WeeklyGames","categories":"categories","Admin/LogoReview":"Admin/LogoReview","Admin/Logs":"Admin/Logs","Admin/Main":"Admin/Main","Admin/Sponsorship":"Admin/Sponsorship","Admin/Users/Users":"Admin/Users/Users","Advertise":"Advertise","Contact":"Contact","Directory":"Directory","Export":"Export","FavesByCountry":"FavesByCountry","Press":"Press","Privacy":"Privacy","TermConditions":"TermConditions","User/Auth/ConfirmAccountView":"User/Auth/ConfirmAccountView","User/Auth/ForgotPassword":"User/Auth/ForgotPassword","User/Auth/Login":"User/Auth/Login","User/Auth/Register":"User/Auth/Register","User/Auth/ResetPassword":"User/Auth/ResetPassword","User/Auth/SocialLogin":"User/Auth/SocialLogin","User/Dashboard":"User/Dashboard","User/Main":"User/Main","about":"about"}[chunkId]||chunkId) + "." + {"Account":"c14288df","Admin/Dashboard~Admin/Engagement":"6ae2db75","Admin/Dashboard":"0ca17145","Admin/Engagement":"21867721","Admin/FavPages/FavPages":"5493dc63","Admin/FavPages/FavPage~FaveItButton~FavesByCountryName.~Home~TopBlogs~TopFaves~TopGames~WeeklyFaves~~1581b57c":"6a53ecd2","Admin/FavPages/FavPage~FaveItButton~Home":"efe17376","Admin/FavPages/FavPage":"cef254cf","FaveItButton":"794ea253","FavesByCountryName.~Home~TopBlogs~TopFaves~TopGames~WeeklyFaves~WeeklyGames~categories":"8d2f86e2","Home":"ccdeed7e","FavesByCountryName.":"c7a75f25","TopBlogs":"666f86b6","TopFaves":"cc717c1b","TopGames":"609ab38c","WeeklyFaves":"6988d9aa","WeeklyGames":"e257060e","categories":"c6a42307","Admin/LogoReview":"47130bf4","Admin/Logs":"5d7fb777","Admin/Main":"40b9a2ec","Admin/Sponsorship":"ba7137d2","Admin/Users/Users":"b9fbd193","Advertise":"f7477975","Contact":"84754b15","Directory":"085b0a97","Export":"67b525a1","FavesByCountry":"d36c6baa","Press":"489cccee","Privacy":"5ba785cc","TermConditions":"67380455","User/Auth/ConfirmAccountView":"b932a51d","User/Auth/ForgotPassword":"82a00226","User/Auth/Login":"6775bc4f","User/Auth/Register":"309d4ac9","User/Auth/ResetPassword":"e9040d2a","User/Auth/SocialLogin":"f204bb6b","User/Dashboard":"df784377","User/Main":"1d52a97f","about":"36c22e18","chunk-235ba322":"2f85d9a1","chunk-3b218918":"475be3ab","chunk-489d870c":"ac398053","chunk-27ee0ecc":"1ee3e9a6","chunk-5351101c":"686844a1"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Account":1,"Admin/Dashboard":1,"Admin/Engagement":1,"Admin/FavPages/FavPages":1,"Admin/FavPages/FavPage~FaveItButton~Home":1,"Admin/FavPages/FavPage":1,"FaveItButton":1,"FavesByCountryName.~Home~TopBlogs~TopFaves~TopGames~WeeklyFaves~WeeklyGames~categories":1,"Home":1,"FavesByCountryName.":1,"Admin/LogoReview":1,"Admin/Logs":1,"Admin/Main":1,"Admin/Sponsorship":1,"Admin/Users/Users":1,"Advertise":1,"Contact":1,"Directory":1,"Export":1,"FavesByCountry":1,"User/Auth/ConfirmAccountView":1,"User/Auth/ForgotPassword":1,"User/Auth/Login":1,"User/Auth/Register":1,"User/Auth/ResetPassword":1,"User/Auth/SocialLogin":1,"User/Dashboard":1,"User/Main":1,"about":1,"chunk-235ba322":1,"chunk-3b218918":1,"chunk-489d870c":1,"chunk-27ee0ecc":1,"chunk-5351101c":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"Account":"Account","Admin/Dashboard~Admin/Engagement":"Admin/Dashboard~Admin/Engagement","Admin/Dashboard":"Admin/Dashboard","Admin/Engagement":"Admin/Engagement","Admin/FavPages/FavPages":"Admin/FavPages/FavPages","Admin/FavPages/FavPage~FaveItButton~FavesByCountryName.~Home~TopBlogs~TopFaves~TopGames~WeeklyFaves~~1581b57c":"Admin/FavPages/FavPage~FaveItButton~FavesByCountryName.~Home~TopBlogs~TopFaves~TopGames~WeeklyFaves~~1581b57c","Admin/FavPages/FavPage~FaveItButton~Home":"Admin/FavPages/FavPage~FaveItButton~Home","Admin/FavPages/FavPage":"Admin/FavPages/FavPage","FaveItButton":"FaveItButton","FavesByCountryName.~Home~TopBlogs~TopFaves~TopGames~WeeklyFaves~WeeklyGames~categories":"FavesByCountryName.~Home~TopBlogs~TopFaves~TopGames~WeeklyFaves~WeeklyGames~categories","Home":"Home","FavesByCountryName.":"FavesByCountryName.","TopBlogs":"TopBlogs","TopFaves":"TopFaves","TopGames":"TopGames","WeeklyFaves":"WeeklyFaves","WeeklyGames":"WeeklyGames","categories":"categories","Admin/LogoReview":"Admin/LogoReview","Admin/Logs":"Admin/Logs","Admin/Main":"Admin/Main","Admin/Sponsorship":"Admin/Sponsorship","Admin/Users/Users":"Admin/Users/Users","Advertise":"Advertise","Contact":"Contact","Directory":"Directory","Export":"Export","FavesByCountry":"FavesByCountry","Press":"Press","Privacy":"Privacy","TermConditions":"TermConditions","User/Auth/ConfirmAccountView":"User/Auth/ConfirmAccountView","User/Auth/ForgotPassword":"User/Auth/ForgotPassword","User/Auth/Login":"User/Auth/Login","User/Auth/Register":"User/Auth/Register","User/Auth/ResetPassword":"User/Auth/ResetPassword","User/Auth/SocialLogin":"User/Auth/SocialLogin","User/Dashboard":"User/Dashboard","User/Main":"User/Main","about":"about"}[chunkId]||chunkId) + "." + {"Account":"22555c5b","Admin/Dashboard~Admin/Engagement":"31d6cfe0","Admin/Dashboard":"48c6716e","Admin/Engagement":"5da48da6","Admin/FavPages/FavPages":"6ddf9b59","Admin/FavPages/FavPage~FaveItButton~FavesByCountryName.~Home~TopBlogs~TopFaves~TopGames~WeeklyFaves~~1581b57c":"31d6cfe0","Admin/FavPages/FavPage~FaveItButton~Home":"eb42c693","Admin/FavPages/FavPage":"8fb4ca23","FaveItButton":"725f176f","FavesByCountryName.~Home~TopBlogs~TopFaves~TopGames~WeeklyFaves~WeeklyGames~categories":"2589f232","Home":"9fb1a956","FavesByCountryName.":"2abf9be9","TopBlogs":"31d6cfe0","TopFaves":"31d6cfe0","TopGames":"31d6cfe0","WeeklyFaves":"31d6cfe0","WeeklyGames":"31d6cfe0","categories":"31d6cfe0","Admin/LogoReview":"50831740","Admin/Logs":"27a61003","Admin/Main":"3a5e54b3","Admin/Sponsorship":"6f08a037","Admin/Users/Users":"fd2c478b","Advertise":"579c8bbd","Contact":"260f929e","Directory":"c0443d05","Export":"179910a6","FavesByCountry":"2fc22344","Press":"31d6cfe0","Privacy":"31d6cfe0","TermConditions":"31d6cfe0","User/Auth/ConfirmAccountView":"0afa5d09","User/Auth/ForgotPassword":"869b3c2c","User/Auth/Login":"8427a711","User/Auth/Register":"7651bef1","User/Auth/ResetPassword":"a8415d73","User/Auth/SocialLogin":"452e1bf0","User/Dashboard":"022ffc93","User/Main":"77dcff27","about":"77dcff27","chunk-235ba322":"c4dda839","chunk-3b218918":"22a6b9db","chunk-489d870c":"b1c6cb37","chunk-27ee0ecc":"b346954b","chunk-5351101c":"894a77e9"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
